import { AxiosError, AxiosResponse } from 'axios';
import api from '../../config/index';
import { EditPrintRuleParams, PrintRule } from '~/@core/domain/model/tag';

export const editPrintRule = (input: EditPrintRuleParams) => {
  return new Promise<void>((resolve, reject) => {
    api
      .put<PrintRule, AxiosResponse>('/tag', input)
      .then((_response: AxiosResponse) => {
        resolve();
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};
